export default "__VITE_ASSET__CoKBsS6z__"